import { createNoise2D, createNoise3D } from 'simplex-noise';
import { seedRandom } from '../utils/math';

export class NoiseGenerator {
  private noise2d: ReturnType<typeof createNoise2D>;
  private noise3d: ReturnType<typeof createNoise3D>;

  constructor(seed: number) {
    const rng = seedRandom(seed);
    this.noise2d = createNoise2D(rng);
    this.noise3d = createNoise3D(rng);
  }

  get2D(x: number, z: number): number {
    return this.noise2d(x, z);
  }

  get3D(x: number, y: number, z: number): number {
    return this.noise3d(x, y, z);
  }

  octave2D(
    x: number, z: number,
    octaves: number,
    persistence = 0.5,
    lacunarity = 2.0,
    scale = 1.0,
  ): number {
    let value = 0;
    let amplitude = 1;
    let frequency = scale;
    let maxAmplitude = 0;

    for (let i = 0; i < octaves; i++) {
      value += this.noise2d(x * frequency, z * frequency) * amplitude;
      maxAmplitude += amplitude;
      amplitude *= persistence;
      frequency *= lacunarity;
    }

    return value / maxAmplitude;
  }

  octave3D(
    x: number, y: number, z: number,
    octaves: number,
    persistence = 0.5,
    lacunarity = 2.0,
    scale = 1.0,
  ): number {
    let value = 0;
    let amplitude = 1;
    let frequency = scale;
    let maxAmplitude = 0;

    for (let i = 0; i < octaves; i++) {
      value += this.noise3d(x * frequency, y * frequency, z * frequency) * amplitude;
      maxAmplitude += amplitude;
      amplitude *= persistence;
      frequency *= lacunarity;
    }

    return value / maxAmplitude;
  }
}
